import { DataObject } from '@shared/models/data-object.model';

/**
 * omits given attributes of a given object
 * @example
 * [{foo:'bar', baz:'baaz'}].map(pluck('foo')); // [{ baz:'baaz'}]
 * [{foo:'bar', baz:'baaz'}].map(pluck('foo', 'baz')); // [{ }]
 */
export const omitItems =
  (...attrs: string[]) =>
  (data: DataObject) => {
    const copyData = { ...data };
    attrs.forEach(a => delete copyData[a]);
    return copyData;
  };
